/* eslint-disable react/prop-types */
import React, { Component } from "react";

class Goal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goalName: props.name, // Updated property
      data: null
    };
  }

  componentDidMount() {
    const { axios, goalName } = this.props;
    axios.get(`/api/goals/${goalName}`).then(response => {
      this.setState({ data: response.data });
    });
  }

  render() {
    const { data } = this.state;
    if (!data) {
      return <div>Loading...</div>;
    }
    return (
      <div>
        <h1>{data.title}</h1>
        <p>{data.description}</p>
      </div>
    );
  }
}

export default Goal;
